/**
 * GapAlertPanel.tsx - Display identified gaps and limitations
 *
 * Shows concepts not found in ontology and inference limitations.
 * Per wobbly-nibbling-chipmunk.md Part 15.3
 */

import './GapAlertPanel.css'

interface GapAlertPanelProps {
  gaps: string[]
  limitations: string[]
  onGapClick?: (gap: string) => void
}

function GapAlertPanel({ gaps, limitations, onGapClick }: GapAlertPanelProps) {
  // Don't render if nothing to show
  if (gaps.length === 0 && limitations.length === 0) {
    return null
  }

  return (
    <div className="gap-alert-panel">
      {/* Gaps section */}
      {gaps.length > 0 && (
        <div className="gaps-section">
          <h4>
            <span className="icon">⚠️</span>
            Gaps Identified
          </h4>
          <ul className="gaps-list">
            {gaps.map((gap, idx) => (
              <li
                key={idx}
                className="gap-item"
                onClick={() => onGapClick?.(gap)}
              >
                <span className="gap-icon">○</span>
                <span className="gap-text">{gap}</span>
                <span className="gap-hint">Not found in ontology</span>
              </li>
            ))}
          </ul>
          <p className="gap-suggestion">
            Consider adding these concepts to improve inference coverage.
          </p>
        </div>
      )}

      {/* Limitations section */}
      {limitations.length > 0 && (
        <div className="limitations-section">
          <h4>
            <span className="icon">ℹ️</span>
            Limitations
          </h4>
          <ul className="limitations-list">
            {limitations.map((limitation, idx) => (
              <li key={idx} className="limitation-item">
                {limitation}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

export default GapAlertPanel
